import { Component, computed, inject, input, output } from '@angular/core';
import { ModalComponent, TypographyComponent } from '@purolator/ui-kit-angular';
import { TranslatePipe, TranslationService } from '../../../../core/i18n';
import { MONERIS_CHECKOUT_HOST_ID } from '../../services/payment-flow.service';

/**
 * Hosts Moneris Checkout inside a puro-modal shell (OM-640 / OM-638).
 * Card entry, billing address, and 3DS challenge UI are rendered by Moneris.
 */
@Component({
  selector: 'app-review-payment-modal',
  imports: [ModalComponent, TranslatePipe, TypographyComponent],
  templateUrl: './review-payment-modal.html',
  styleUrl: './review-payment-modal.scss',
})
export class ReviewPaymentModal {
  private readonly translation = inject(TranslationService);

  readonly open = input(false);
  /** True while shipment creation runs after Moneris reports payment complete. */
  readonly processing = input(false);
  readonly closed = output<void>();

  protected readonly hostId = MONERIS_CHECKOUT_HOST_ID;

  protected readonly modalTitle = computed(() => {
    this.translation.revision();
    return this.translation.translate('createShipment.reviewAndPay.paymentModal.title');
  });

  /**
   * Closes the checkout shell and notifies the parent to cancel the payment flow.
   */
  protected onClose(): void {
    this.closed.emit();
  }
}
